<div *ngIf="ring" class="ring" [style.height]="ringHeight">
	<div class="ring-title" [style.fontSize]="ringTitleSize">
		Ring {{ ring.name }}
	</div>
	<div class="groups" *ngIf="ring.groups">
		<div *ngFor="let group of ring.groups" [style.fontSize]="groupFontSize">
			{{ group.name }}
		</div>
	</div>
</div>
